(function () {
    function init() {
        var grid = document.getElementById('collection-products');
        var filter = document.querySelector('.claude-cols-filter');
        if (!grid || !filter) return;

        var STORAGE_KEY = 'sosauto_products_per_row';
        var buttons = filter.querySelectorAll('.claude-cols-btn');
        var saved = null;
        try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
        var current = saved || '4';

        function apply(cols) {
            grid.classList.remove('claude-cols-2', 'claude-cols-4', 'claude-cols-8');
            grid.classList.add('claude-cols-' + cols);
            for (var i = 0; i < buttons.length; i++) {
                var btn = buttons[i];
                if (btn.getAttribute('data-cols') === cols) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            }
        }

        apply(current);

        for (var i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener('click', function () {
                var cols = this.getAttribute('data-cols');
                apply(cols);
                try { localStorage.setItem(STORAGE_KEY, cols); } catch (e) {}
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
